import logo from "../../assets/image/logo.png";
import { Link } from "react-router-dom";
// import linkedinLogo from "../../assets/image/linkedin.svg";
// import styled from "styled-components";
// import appConfig from "../../config/appConfig.json";
// const SocialLinks = styled.div`
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   column-gap: 8px;
//   a {
//     max-width: 42px;
//     align-items: center;
//     display: flex;
//     justify-content: center;
//   }
// `;
const Footer = () => {
  return (
    <div className="footer wf-section">
      <div className="footer-container w-container">
        <div className="w-layout-grid footer-grid _2-grid">
          <div className="footer-main-box">
            <Link
              data-ix="logo"
              to="/"
              aria-current="page"
              className="footer-logo w-nav-brand w--current">
              <img
                src={logo}
                width={156}
                alt="Chainerist Teams NFTs"
                className="logo"
              />
            </Link>
          </div>
          <div className="_2-grid _2-on-mobile">
            <div className="footer-links-container">
              <h5 className="footer-header">Site</h5>
              <Link
                to="/"
                aria-current="page"
                className="footer-link w--current">
                Anasayfa
              </Link>
              <Link to="/gallery" className="footer-link">
                Galeri
              </Link>
              <Link to="/contact" className="footer-link">
                İletişim
              </Link>
              {/* <Link to="/terms-conditions" className="footer-link">
                Terms &amp; Conditions
              </Link> */}
              {/* <Link href="/privacy-policy" className="footer-link">
                Privacy Policy
              </Link> */}
            </div>
            {/* <SocialLinks>
              <a
                href={appConfig.twitter}
                className="footer-social-link-block w-inline-block"
                target="_blank"
                rel="noreferrer">
                <img
                  src="https://assets.website-files.com/619f485207368e1139a39a1c/61ab3a32fc6b256c7902084b_Twitter%20-%20Negative.svg"
                  loading="lazy"
                  width={33}
                  alt="Twitter Icon"
                  className="social-icon"
                />
              </a>
              <a
                href={appConfig.discord}
                className="footer-social-link-block w-inline-block"
                target="_blank"
                rel="noreferrer">
                <img
                  src="https://assets.website-files.com/619f485207368e1139a39a1c/61ab3a32b8be1230b2fdcf89_Discord%20-%20Negative.svg"
                  loading="lazy"
                  width={33}
                  alt="Discord Icon"
                  className="social-icon"
                />
              </a>
              <a
                href={appConfig.linkedin}
                className="footer-social-link-block w-inline-block"
                target="_blank"
                rel="noreferrer">
                <img
                  src={linkedinLogo}
                  loading="lazy"
                  width={33}
                  alt="LinkedIn Icon"
                  className="social-icon"
                />
              </a>
            </SocialLinks> */}
            {/* <div className="footer-links-container">
              <h5 className="footer-header">Admin</h5>
              <a href="/admin/style-guide" className="footer-link">
                Style Guide
              </a>
              <a href="/admin/licenses" className="footer-link">
                Licenses
              </a>
              <a href="/admin/instructions" className="footer-link">
                Instructions
              </a>
              <a href="/401" className="footer-link">
                Password
              </a>
              <a href="/404" className="footer-link">
                404
              </a>
            </div> */}
          </div>
          {/* <div
              id="w-node-c5654a67-12b1-479f-db87-277295a55cb7-cf3fcb86"
              className="text-box _500px">
              <p className="paragraph small">
                Built by{" "}
                <a
                  href="https://www.nikolaibain.com"
                  target="_blank"
                  className="link blue">
                  Nikolai Bain
                </a>
                . Powered by{" "}
                <a
                  href="http://www.webflow.com"
                  target="_blank"
                  className="link blue">
                  Webflow
                </a>
                .<br />
              </p>
            </div>  */}
        </div>
      </div>
    </div>
  );
};

export default Footer;
